import { map } from 'lodash';

const UNAUTHORIZED = 'UNAUTHORIZED';

export const formatErrors = (error) => {
  const { graphQLErrors, networkError } = error;
  if (networkError) {
    return 'Currently unable to process request.';
  }
  const errorMessages = map(graphQLErrors, 'message');
  return errorMessages.join(', ');
};

export const unauthorizedError = (error) => {
  const { graphQLErrors } = error;

  if (graphQLErrors) {
    const errorTypes = map(graphQLErrors, 'type');
    return errorTypes.includes(UNAUTHORIZED);
  }
  return false;
};

export default {
  unauthorizedError,
  formatErrors,
};
